import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';
import CodDecisaoMovCNJ from '../CodDecisaoMovCNJ';
import EmentaDecisao from './components/EmentaDecisao';
import RascunhoCertidaoComCarregamento from './components/RascunhoCertidaoComCarregamento';
import { computed, makeObservable } from 'mobx';
import RodapePainelDecisao from './components/RodapePainelDecisao';
import ComparacaoDecisaoRascunhoCertidao from './components/ComparacaoDecisaoRascunhoCertidao';
import { Box } from '@mui/material';

class PainelDecisaoSessao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    flexGrow: '2'
                }}
            >
                <div style={{ paddingRight: '8px' }}>
                    <CodDecisaoMovCNJ
                        registro={this.registro}
                        id="decisao"
                    />
                </div>
                <EmentaDecisao registro={this.registro} />
                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, pb: 0.5, position: 'relative' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            position: 'absolute',
                            width: '100%',
                            alignItems: 'flex-end',
                            top: '-2px'
                        }}
                    >
                        <ComparacaoDecisaoRascunhoCertidao registro={this.registro} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pt: 1 }}>
                        <RascunhoCertidaoComCarregamento registro={this.registro} />
                    </Box>
                </Box>
                <RodapePainelDecisao registro={this.registro} />
            </div>
        );
    }
}

export default inject('stores')(observer(PainelDecisaoSessao));
